import PropertyFormGeneric from "@rf/property/module/components/property-form/PropertyFormGeneric";
import { useCreatePropertyMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import toast from "react-hot-toast";

import { UseFormReturn } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import { HToastCatchServerError } from "@rf-helper/cath-error-server";
import { useCallback, useEffect, useMemo } from "react";
import { useResetAllFormStates } from "@rf/property/module/components/property-form/store/propertyStore";
import dispatchMessagesOverlay from "@rf-l1/loading/mx-overlay-loading/util/dispatchMessagesOverlay";
import simulatorRequest from "@rf-helper/simulator-request";
import {
  CPropertyFormKeys,
  CPropertyForm,
  IPropertyForm
} from "../../components/property-form/util/schemas/property-schema/propertySchema";
import CreatePropertyAdapter from "../../adapters/form/create-property-adapter";
import { PROPERTIES_MAIN_OVERLAY_ID } from "../../components/property-form/util/const/properties-overlays.const";
import { C_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";

const PropertyCreationPage = () => {
  const [CREATE_PROPERTY_M] = useCreatePropertyMutation();
  const resetAllFormStates = useResetAllFormStates();
  const router = useNavigate();

  useEffect(() => {
    return () => {
      resetAllFormStates();
    };
  }, []);

  const handleSubmit = useCallback(
    async (v: IPropertyForm, helper: UseFormReturn<IPropertyForm>) => {
      // try {
      dispatchMessagesOverlay("Guardando propiedad", PROPERTIES_MAIN_OVERLAY_ID);
      // const p = {
      //   body: {
      //     is_project: 0,
      //     payload: {
      //       encode: createPayloadDraft(v)
      //     }
      //   }
      // };

      // CREATE_DRAFT_M(p)
      //   .unwrap()
      //   .catch(e => HToastCatchServerError(e));

      await simulatorRequest({
        onEndSimulated: "resolve"
      });

      dispatchMessagesOverlay(
        "Estamos dándole forma a tu propiedad",
        PROPERTIES_MAIN_OVERLAY_ID
      );

      const body = CreatePropertyAdapter(v);

      const res = (await CREATE_PROPERTY_M({ body })
        .unwrap()
        .catch(e => HToastCatchServerError(e))) as any;

      dispatchMessagesOverlay(
        "¡Casi listo! Tu propiedad estará disponible en breve.",
        PROPERTIES_MAIN_OVERLAY_ID
      );

      if (res?.data?.id) {
        // await DELETE_DRAFT_M({
        //   query: {
        //     is_project: 0
        //   }
        // })
        //   .unwrap()
        //   .catch(e => HToastCatchServerError(e));

        helper.reset(CPropertyForm as unknown as IPropertyForm);

        router(
          `${C_PATH_ROUTES.REALESTATE.DETAIL(res.data.id)}?isNewProperty=true`,
          {
            replace: true
          }
        );
      } else {
        toast.error("Failed to retrieve property data");
      }
      // } catch (e: any) {
      //   console.error(e);
      // }
    },
    []
  );

  const stateForm = useMemo(() => {
    return {
      ...CPropertyForm,
      [CPropertyFormKeys.is_project]: false,
      [CPropertyFormKeys.is_edit]: false
    } as unknown as IPropertyForm;
  }, []);

  return <PropertyFormGeneric state={stateForm} onSubmit={handleSubmit} />;
};

export default PropertyCreationPage;
